<div class = "dialog-container">
    <div class = "confirm-span header9">
        Are you sure you want to push?
    </div>
    <div class = "button-container">
        <button mat-raised-button class = "button padding" (click) = "close()">No, I am still working!</button>
        <button mat-raised-button class = "padding" color="accent" (click) = "save()" id="configBtn">Yes, push Chart(s)!</button>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>
